<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-pricetag"></i>
        <div class="mg-l-20">
          <h4>{{ $t("mall.商品自定义标签管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          class="tx-info mg-r-15"
          href="javascript:;"
          @click="accordionProducts"
          >{{ isAccordion ? $t("mall.展开标签") : $t("mall.折叠标签") }}</a
        >
        <button
          class="btn btn-success"
          type="button"
          @click="addNew"
          v-if="isSysRights('SupplierProductCategorys.addBySupplier')"
        >
          {{ $t("mall.添加新标签") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("mall.标签名称：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("mall.是否在商城显示：") }}
          <span class="mg-r-10">{{ $t($dict.labelStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyStatus", "isAccordion", "batchBool"],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    accordionProducts() {
      //$t('mall.折叠商品')
      this.$emit("accordionProducts", !this.isAccordion);
    },
    addNew() {
      this.$emit("addNew");
    },
  },
};
</script>